import React, { useState, useEffect } from "react"
import axios from "axios"
import {
  Table,
  Button,
  Input,
  Card,
  CardBody,
  ModalHeader,
  Modal,
  Label,
  Row,
  Col,
  Container
} from "reactstrap"
import Breadcrumbs from "../components/Common/Breadcrumb"
import ReactPaginate from "react-paginate"
import { ToastContainer, toast } from "react-toastify"
import { URLS } from "../Url"
import { saveAs } from "file-saver"

const Posters = () => {
  const [lists, setLists] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage] = useState(5)
  const [searchTerm, setSearchTerm] = useState("")
  const [modal_small2, setmodal_small2] = useState(false)
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const token = authUser?.token

  // API
  const fetchData = () => {
    axios
      .post(
        URLS.GetPosters,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        if (res.data.success) {
          setLists(res.data.userPosts || [])
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error)
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  function tog_small2() {
    setmodal_small2(!modal_small2)
  }

  const getpopup2 = () => {
    tog_small2()
  }

  const indexOfLastItem = (currentPage + 1) * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage

  const filteredItems = Array.isArray(lists)
    ? lists.filter(item =>
        (item.userName?.toLowerCase() || "").includes(searchTerm?.toLowerCase())
      )
    : []

  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem)
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage)

  // Page change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected)
  }

  // Search
  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
    setCurrentPage(0)
  }

  // checkbox funtinality

  const [selectedIds, setSelectedIds] = useState([])
  console.log(selectedIds, "selectedIds")

  const handleSelectAll = () => {
    if (selectedIds.length === filteredItems.length) {
      setSelectedIds([])
    } else {
      const allIds = filteredItems.map(data => data._id)
      setSelectedIds(allIds)
    }
  }

  const handleSelectOne = _id => {
    if (selectedIds.includes(_id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== _id))
    } else {
      setSelectedIds([...selectedIds, _id])
    }
  }

  const isSelected = _id => selectedIds.includes(_id)
  const [idsToDelete, setIdsToDelete] = useState([])

  // Delete
  const DeleteCategory = () => {
    if (selectedIds.length === 0) {
      toast("Select atleast one product!")
      setmodal_small2(false)
    } else {
      var token = datas
      var remid = { selectedIds }
      axios
        .delete(URLS.DeletePosters, {
          headers: { Authorization: `Bearer ${token}` },
          data: { id: selectedIds },
        })
        .then(
          res => {
            if (res.status === 200 || res.data.success) {
              toast.success(`Deleted Successfully`)
              fetchData()
              setmodal_small2(false)
            } else {
              toast.error(`Error deleting item. Status: ${res.status}`)
            }
          },
          error => {
            if (error.response && error.response.status === 400) {
              toast(error.response.data.message)
            }
          }
        )
    }
  }

  // date and the timesaas
  const formatDateToIST = dateStr => {
    if (!dateStr) return "N/A"
    const date = new Date(dateStr)
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  // Downlod image and videoo
  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Home " breadcrumbItem="Uploads" />
      <div className="container-fluid">
        <Card>
          <CardBody>
            <div className="table-rep-plugin table-responsive">
              <Row className="mb-4">
                <Col md={6}>
                  {" "}
                  <div>
                    <Button
                      onClick={() => {
                        getpopup2()
                      }}
                      className="mr-2 mt-2"
                      size="sm"
                      color="danger"
                    >
                      <i className="bx bx-trash"></i> Delete All
                    </Button>{" "}
                  </div>{" "}
                </Col>
                <Col md={6}>
                  <div style={{ float: "right" }}>
                    <Input
                      name="search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      type="search"
                      placeholder="Search..."
                      style={{ width: "200px" }}
                    />
                  </div>
                </Col>
              </Row>
              <Table hover bordered responsive>
                <thead className="text-center">
                  <tr>
                    <th>
                      <Label>Select_All</Label>
                      <Input
                        type="checkbox"
                        onClick={handleSelectAll}
                        checked={
                          selectedIds.length === filteredItems.length &&
                          filteredItems.length > 0
                        }
                        readOnly
                        style={{
                          height: "17px",
                          width: "17px",
                          cursor: "pointer",
                          marginLeft: "12px",
                        }}
                      />
                    </th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Video</th>
                    <th>Expiry Date/Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {currentItems.map((data, key) => (
                    <tr key={key} className="text-center">
                      {/* <th scope="row">{indexOfFirstItem + index + 1}</th> */}
                      <th>
                        {(currentPage - 1) * 5 + key + 6}){" "}
                        <Input
                          type="checkbox"
                          onClick={() => handleSelectOne(data._id)}
                          // checked={isSelected(data._id)}
                          // readOnly
                          style={{
                            height: "17px",
                            width: "17px",
                            cursor: "pointer",
                            marginLeft: "2px",
                          }}
                        />
                      </th>
                      <td>{formatDateToIST(data.logCreatedDate)}</td>
                      <td>{data.userName}</td>
                      <td>
                        <div className="d-inline-flex align-items-center">
                          <img
                            src={
                              data.thumbnail
                                ? URLS.Base + data.thumbnail
                                : URLS.Base + data.image
                            }
                            alt="Media"
                            style={{ width: "80px", cursor: "pointer" }}
                          />
                          <i
                            className="bx bx-download"
                            style={{
                              fontSize: "24px",
                              color: "#007bff",
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              downloadImage(
                                data.thumbnail
                                  ? URLS.Base + data.thumbnail
                                  : URLS.Base + data.image
                              )
                            }
                          ></i>
                        </div>
                      </td>
                      <td>
                        {data.thumbnail ? (
                          <div className="d-inline-flex align-items-center">
                            <video
                              width="200px"
                              height="200px"
                              controls
                              style={{ cursor: "pointer" }}
                            >
                              <source
                                src={URLS.Base + data.image}
                                type="video/mp4"
                              />
                            </video>
                            <i
                              className="bx bx-download"
                              style={{
                                fontSize: "24px",
                                color: "#007bff",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                downloadImage(URLS.Base + data.image)
                              }
                            ></i>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>{formatDateToIST(data.expiryDateTime)}</td>
                      <td className="text-center">
                        {Roles?.UploadCategoryDelete == true ||
                        Roles?.accessAll == true ? (
                          <>
                            <Button
                              className="btn-sm"
                              color="danger"
                              onClick={() => DeleteCategory(data._id)}
                            >
                              <i className="bx bx-trash m-1"></i>
                            </Button>
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <div className="mt-3" style={{ float: "right" }}>
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  previousLinkClassName={"previousBttn"}
                  nextLinkClassName={"nextBttn"}
                  disabledClassName={"disabled"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </CardBody>
        </Card>
 
      </div>
      </Container>
    
      <Modal
          size="md"
          isOpen={modal_small2}
          toggle={() => {
            tog_small2()
          }}
          centered
        >
          <ModalHeader className="border-bottom-0">
            {" "}
            <button
              onClick={() => {
                setmodal_small2(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <div className="modal-body">
            <div className="text-center mb-2">
              <div className="avatar-md mx-auto mb-2">
                <div className="avatar-title bg-light  rounded-circle text-primary h1">
                  <i className="bx bx-trash text-danger"></i>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-xl-10">
                  <h4 className="text-danger mb-3">
                    Do you really want to delete this all Posters?
                  </h4>
                </div>
              </div>
            </div>
            <hr></hr>
            <div style={{ float: "right" }}>
              <Button
                onClick={() => {
                  setmodal_small2(false)
                }}
                color="warning"
                type="button"
              >
                Cancel <i className="fas fa-times-circle"></i>
              </Button>

              <Button
                color="danger"
                type="button"
                id="button-addon2"
                className="m-1"
                onClick={() => {
                  DeleteCategory()
                }}
              >
                <i className="bx bx-trash text-white"></i> Delete
              </Button>
            </div>
          </div>
        </Modal>
        <ToastContainer />
    </div>
  </React.Fragment>
  )
}

export default Posters
